import { useEffect, useState, useCallback, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { WindowWidthContext } from "../App";

function Header() {
  const windowWidth = useContext(WindowWidthContext);

  const [visible, setVisible] = useState(false);
  const [path, setPath] = useState("/");

  const location = useLocation();

  useEffect(() => {
    if (windowWidth > 1000) {
      setVisible(false);
    }
  }, [windowWidth]);

  useEffect(() => {
    setPath(location.pathname);
  }, [location.pathname]);

  return (
    <div className="home__header">
      <Link to="/">
        <h1>Xander</h1>
      </Link>

      <ul
        className={
          visible
            ? "home__header__nav-links home__header__nav-links--visible"
            : "home__header__nav-links"
        }
      >
        <li
          onClick={() => {
            setVisible(false);
          }}
        >
          <Link to={path === "/gallery" ? "/" : "/gallery"}>
            {path === "/gallery" ? "Home" : "Photo Gallery"}
            <span></span>
          </Link>
        </li>
        <li
          onClick={() => {
            setVisible(false);
          }}
        >
          <Link to={path === "/about" ? "/" : "/about"}>
            {path === "/about" ? "Home" : "About"}
            <span></span>
          </Link>
        </li>
      </ul>

      <div
        className="home__header__hamburger"
        onClick={() => {
          setVisible((prev) => !prev);
        }}
      >
        <div className="home__header__hamburger__line home__header__hamburger__line-1"></div>
        <div className="home__header__hamburger__line home__header__hamburger__line-2"></div>
        <div className="home__header__hamburger__line home__header__hamburger__line-3"></div>
      </div>
    </div>
  );
}

export default Header;
